import styled from 'styled-components';

export const Video = styled.video`
  max-width: 23.75rem;
`;
